import { NotificationConfiguration } from '../notification.templates';

export const ADMIN_CONNECTED_USERS_TEMPLATE: NotificationConfiguration = {
  inapp: `Your Admin <b>{triggeredByName}</b> has connected your user to <b>{mentionedUsers}</b>.`,
  email: {
    ctaKey: 'go_to_settings',
  },
};
